import React from "react";

const Header = () => {
  return (
    <section className="header">
      <h1 className="header__title">
        <span className="header__logo">Dave and Buster's</span>
        <span className="header__tagline">NFT Collection</span>
      </h1>
    </section>
  );
};

export default Header;
